// ../../packages/build/src/injections/dev.js
var __DEV__ = process.env.NODE_ENV !== "production";

// src/constants.ts
var SENDER = "devtools";
var DEVTOOLS_ID = "harlem";
var ALL_STORES_ID = "$all";
var OPTIONS = {
  label: "Harlem",
  color: 4244621
};

// src/index.ts
import {
  EVENTS
} from "@harlem/core";
import {
  setupDevtoolsPlugin
} from "@vue/devtools-api";
function stringComparitor(valueA, valueB) {
  return valueA.localeCompare(valueB);
}
function getInspectorTreeHook(application, stores) {
  return (payload) => {
    const {
      app,
      inspectorId
    } = payload;
    if (app !== application || inspectorId !== DEVTOOLS_ID || stores.size === 0) {
      return;
    }
    const children = Array.from(stores.keys()).sort(stringComparitor).map((name) => ({
      id: name,
      label: name
    }));
    payload.rootNodes = [
      {
        children,
        id: ALL_STORES_ID,
        label: "Stores"
      }
    ];
  };
}
function getStoreSnapshot(store) {
  const state = [
    {
      key: store.name,
      value: store.state,
      editable: true
    }
  ];
  const getters = Array.from(store.getters).sort(([a], [b]) => stringComparitor(a, b)).map(([key, accessor]) => ({
    key,
    value: accessor(),
    editable: false,
    objectType: "computed"
  }));
  const mutations = Array.from(store.mutations).sort(([a], [b]) => stringComparitor(a, b)).map(([key, mutator]) => ({
    key,
    value: mutator,
    editable: false
  }));
  return {
    state,
    getters,
    mutations
  };
}
function getStoreSnapshots(stores) {
  return stores.reduce((output, store) => {
    if (!store) {
      return output;
    }
    const snapshot = getStoreSnapshot(store);
    return {
      state: [...output.state, ...snapshot.state],
      getters: [...output.getters, ...snapshot.getters],
      mutations: [...output.mutations, ...snapshot.mutations]
    };
  }, {
    state: [],
    getters: [],
    mutations: []
  });
}
function getInspectorStateHook(application, stores) {
  return (payload) => {
    const {
      app,
      inspectorId,
      nodeId
    } = payload;
    if (app !== application || inspectorId !== DEVTOOLS_ID || stores.size === 0) {
      return;
    }
    let internalStores = [stores.get(nodeId)];
    if (nodeId === ALL_STORES_ID) {
      internalStores = Array.from(stores.values());
    }
    payload.state = getStoreSnapshots(internalStores);
  };
}
function getInspectorEditHook(application, stores) {
  return (payload) => {
    const {
      app,
      inspectorId,
      nodeId,
      path,
      state,
      set
    } = payload;
    if (app !== application || inspectorId !== DEVTOOLS_ID || stores.size === 0) {
      return;
    }
    const root = path.shift();
    const storeId = nodeId === ALL_STORES_ID ? root || nodeId : nodeId;
    const store = stores.get(storeId);
    if (!store) {
      return;
    }
    store.write("plugin:devtools:set", SENDER, (_state) => set(_state, path, state.value));
  };
}
function getMutationHook(api, logType) {
  return (payload) => {
    if (!payload) {
      return;
    }
    const {
      sender,
      store
    } = payload;
    api.sendInspectorState(DEVTOOLS_ID);
    api.addTimelineEvent({
      layerId: DEVTOOLS_ID,
      event: {
        logType,
        title: "Mutation",
        subtitle: store,
        time: Date.now(),
        data: payload,
        groupId: sender,
        meta: {
          store
        }
      }
    });
  };
}
function createDevtoolsPlugin(options = OPTIONS) {
  const {
    label,
    color
  } = {
    ...OPTIONS,
    ...options
  };
  return {
    name: "devtools",
    install(app, eventEmitter, stores) {
      const inspectorTreeHook = getInspectorTreeHook(app, stores);
      const inspectorStateHook = getInspectorStateHook(app, stores);
      const inspectorEditHook = getInspectorEditHook(app, stores);
      const descriptor = {
        app,
        label,
        id: DEVTOOLS_ID,
        logo: "https://harlemjs.com/assets/images/favicon.png",
        homepage: "https://harlemjs.com",
        packageName: "@harlem/plugin-devtools"
      };
      setupDevtoolsPlugin(descriptor, (api) => {
        const afterMutationHook = getMutationHook(api);
        const errorMutationHook = getMutationHook(api, "error");
        api.addInspector({
          label,
          id: DEVTOOLS_ID,
          icon: "source",
          treeFilterPlaceholder: "Search stores"
        });
        api.addTimelineLayer({
          label,
          color,
          id: DEVTOOLS_ID,
          skipScreenshots: true
        });
        api.on.getInspectorTree(inspectorTreeHook);
        api.on.getInspectorState(inspectorStateHook);
        api.on.editInspectorState(inspectorEditHook);
        eventEmitter.on(EVENTS.mutation.after, afterMutationHook);
        eventEmitter.on(EVENTS.mutation.error, errorMutationHook);
      });
    }
  };
}
export {
  createDevtoolsPlugin as default
};
//# sourceMappingURL=harlem-devtools.bundler.esm.js.map
